export const ID_BASE_LOCATION_OTHER = 40;
